<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text class="float-left" small @click="getDataForTable(url)" v-bind="attrs"
                               v-on="on"><span class="material-icons">refresh</span></v-btn>
                    </template>
                    <span>به روز رسانی لیست املاک من</span>
                </v-tooltip>
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="historyModal"
                                v-model="historyModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >
                                    <v-toolbar-title>ایجاد تاریخچه</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="historyModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <list-history :estate="true" :id="related_id"></list-history>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-if="relatedModal"
                                v-model="relatedModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>ویرایش فایل</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="relatedModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <edit-simple v-if="relatedModal" :modal="()=>{this.relatedModal=false}"
                                             :editToken="related_id"></edit-simple>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-if="showMore"
                                v-model="showMore"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showMore = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <more-information :information="related_id"></more-information>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template>
                    <v-dialog
                            v-model="filters"
                            max-width="1200"
                            hide-overlay
                            transition="dialog-bottom-transition"
                    >
                        <v-card>
                            <v-toolbar
                                    flat
                                    dark
                                    color="primary"
                            >

                                <v-toolbar-title>فیلتر</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                            icon
                                            dark
                                            @click="filters = false"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <filters :resetBtn="()=>{getDataForTable(url)}" ref="tableFilters" v-model="search"
                                     :action="filterAction"></filters>
                        </v-card>
                    </v-dialog>
                </template>

                <!--      end edit mode -->

                <v-tabs v-model="tab" color="deep-purple accent-4" class="mt-5" grow>
                    <v-tab v-for="item in TabsName" :key="item.value">{{ item.name }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card v-if="tab === 0" :loading="loading" class="p-3 pt-0">
                            <div class="row my-2">
                                <div class="col-md-4 mb-0 pb-0">
                                    <v-autocomplete
                                            :items="officers"
                                            @change="getDataForTable(url)"
                                            item-text="owner"
                                            v-model="officers_id"
                                            class="mb-0 pb-0"
                                            item-value="owner_id"
                                            label="فایل های "
                                            dense outlined
                                    ></v-autocomplete>
                                </div>
                                <div v-if="officers_id ==='شخصی'" :class="!isMobile?'col-md-4' : 'col-12 mb-0 pb-0' ">
                                    <v-autocomplete outlined dense label="مشتریان"
                                                    placeholder="نام مشتری مورد نظر را جستجو کنید."
                                                    v-model="customer_id"
                                                    clearable
                                                    @change="getDataForTable(url)"
                                                    clear-icon="mdi-close-circle-outline"
                                                    prepend-inner-icon="fa fa-pencil-alt"
                                                    :items="customers" item-text="name" item-value="id"
                                                    name="city">
                                    </v-autocomplete>
                                </div>

                                <div v-if="Object.keys(search).length > 0 " :class="!isMobile? 'col-md ': 'mr-4 mt-2' ">
                                    <v-btn @click="resetFilter" outlined class="float-left mr-auto" color="red">
                                        <span class="fa fa-trash-alt ml-1" style="font-size: 10pt"></span>
                                        حذف فیلتر
                                    </v-btn>
                                </div>
                                <div :class="Object.keys(search).length > 0 && isMobile ? ' mr-auto m-0 p-0 text-left' : 'col-md m-0 p-0'">
                                    <v-btn @click="filters=true" class="btn-update float-left">
                                        <span class="fa fa-filter"></span>
                                        انتخاب فیلترها
                                    </v-btn>
                                </div>

                            </div>

                            <terminal-table class="col-12" :currentPage="datas.current_page"
                                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                            :pageCount="datas.last_page"
                                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                            <data-table
                                    v-else
                                    :data="datas"
                                    :columns="columns"
                                    :debounce-delay="3000"
                                    :pagination="paginate"
                                    :orderBy="tableProps.column"
                                    :orderDir="tableProps.dir"
                                    :translate="translate"
                                    :per-page="[10, 25, 50, 100, 500]"
                                    @on-table-props-changed="reloadTable"
                                    class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                            ></data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <new-estate v-if="tab === 1"></new-estate>
                    </v-tab-item>
                </v-tabs-items>

            </div>
        </v-app>
    </div>
</template>

<script>
import {dataTableProps} from "@/main";
import {debounce} from "../../../../custom";
import button from "../../button";
import NewEstate from "./newEstate";
import MoreInformation from "./moreInformation";
import EditSimple from "./editEstate";
import AddHistory from "./addHistory";
import ListHistory from "./history/listHistory";
import Filters from "../divarDependency/filters";
import {Axios2} from "../../../../main";


export default {
    name: "estate_list",
    components: {Filters, ListHistory, AddHistory, EditSimple, MoreInformation, NewEstate},
    data() {
        return {
            search: {},
            tarafeName: "",
            customer_id: "",
            TabsName: [{name: 'لیست فایل های من ', value: 'list'}, {name: 'ثبت فایل جدید', value: 'newCustomer'}],
            tab: "",
            authModal: false,
            loading: false,
            filters: false,
            adsModal: false,
            relatedModal: false,
            historyModal: false,
            showMore: false,
            related_id: null,
            datas: {},
            mine: [],
            myRes: [],
            officers: [
                {owner: 'همه', owner_id: "all"},
                {owner: 'شخصی', owner_id: undefined}
            ],
            activeComponent: '',
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/user/estate`,
            selectedNumber: [],
            translates: [],
            dataId: '',
            officers_id: "شخصی",
            adsList: '',
            nowTime: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox:true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'عنوان ',
                    name: 'title',
                    orderable: true,
                    primary: true,
                    searchable: true,
                },
                {
                    label: 'منتشر کننده ',
                    name: 'type',
                    transform(val) {
                        return {'personal': 'شخص', 'divar': 'دیوار'}[val.data.type]
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'شهر / محله',
                    name: 'city',
                    transform: (val) => {
                        return this.translator("city_" + val.data.city);

                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'متراژ',
                    name: 'size',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'آگهی دهنده',
                    name: 'customer.name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'کد فایل',
                    name: 'identifier',
                    transform(val) {
                        return `<span class="badge badge-info">${val.data.identifier || 'ندارد'}</span>`
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'انتقال به بایگانی',
                                icon: 'exchange-alt',
                                class: 'btn-outline-info',
                                action: this.actions,
                            },
                            {
                                name: 'show',
                                label: 'نمایش اطلاعات',
                                icon: 'eye',
                                class: 'btn-outline-primary',
                                action: this.actions,
                            },
                            {
                                name: 'edit',
                                label: 'ویرایش اطلاعات',
                                icon: 'edit',
                                class: 'btn-outline-warning',
                                action: this.actions,
                                condition: () => {
                                    return this.officers_id === "شخصی";
                                }
                            },
                            {
                                name: 'history',
                                label: 'ایجاد تاریخچه',
                                icon: 'history',
                                class: 'btn-outline-success',
                                action: this.actions,
                            },

                        ]
                    }
                },
            ],
            updatedData: [],
            authResult: [],
            customers: [],
        }
    },
    methods: {
        filterAction() {
            this.search = Object.fromEntries(Object.entries(this.search).map(([key, value]) => {
                return [key, (value === "" || JSON.stringify(value) === "{}") ? undefined : value]
            }))
            this.getDataForTable();
            this.filters = false
        },
        translator(name) {
            return this.translates[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            this.datas = [];
            this.loading = true;

            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: Object.assign(
                    {},
                    query,
                    {agent: (this.officers_id != null && this.officers_id !== 'شخصی') ? this.officers_id : undefined},
                    {customer_id: this.customer_id != null ? this.customer_id : undefined},
                    this.search
                ),
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.datas = data.data;
                    this.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید انتقال', 'آیا از انتقال این فایل اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/user/estate/${data.id}`,
                        method: 'DELETE',
                        msg: false,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.$nextTick(() => {
                                this.$modal.success('موفق!', 'انتقال فایل با موفقیت انجام شد.')
                            })
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        editAction: function (data) {
            this.relatedModal = true;
            this.related_id = data.id
        },
        historyAction: function (data) {
            console.log(data)
            this.historyModal = true;
            this.related_id = data.id
        },
        showAction: function (data) {
            this.showMore = true;
            this.related_id = data.id
        },
        allowOnlyNumbers(value) {
            if (typeof Number(value.key) !== 'string') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        getLocalization() {
            if (localStorage.getItem('localization')) {
                this.translates = JSON.parse(localStorage.getItem('localization'));
                return;
            }
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.translates = data.data
                    localStorage.setItem('localization', JSON.stringify(data.data));
                }
            })
        },
        getOfficers() {
            $.ajax({
                url: `${url}/user/agents/office`,
                type: 'GET',
                fn: this.getOfficers,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.officers.push(...data.data);
                }
            })
        },
        getTimesForNow() {
            $.ajax({
                url: `${url}/setting/clock`,
                fn: this.getTimesForNow,
                type: 'GET',
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.nowTime = data.data.time_stamp;
                }
            });
        },
        getCustomers() {
            Axios2.get('/user/customer/all').then((res) => {
                this.customers = res.data.data;
            })
        },
        resetFilter(){
            this.$refs.tableFilters.resetFilter();

            this.getDataForTable(this.url);
        }
    },
    mounted() {
        this.getCustomers();
        this.getOfficers();
        if (localStorage.getItem('localization')) {
            this.translates = JSON.parse(localStorage.getItem('localization'));
            return;
        } else {
            this.getLocalization();
        }
        this.getDataForTable(this.url);
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
    watch: {
        tab: function (val) {
            if (val === 0) {
                this.reloadTable();
            }
        },
        historyModal(value) {
            if (value)
                this.getTimesForNow();
        }

    },
    computed: {
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },

}
</script>

<style scoped>

</style>